import React from 'react';
import { Link } from 'react-router-dom';
import Loadable from 'react-loadable';
import Pym from 'pym.js';
// import QdtComponent from '../components/QdtComponent';
import Loading from './Loading';
import LeftNav from './LeftNav';

const QdtComponent = Loadable({
  loader: () => import('../components/QdtComponent'),
  loading: Loading,
});

class Page extends React.Component {
  componentDidMount() {
    const pymChild = new Pym.Child();
    pymChild.sendHeight();
    window.scrollTo(0, 0);
  }

  //   AND <span className="red"><QdtComponent type="QdtKpi" props={{ cols: ['=Count(distinct state)'] }} /> STATES</span>
  render() {
    const { props } = this;
    return (
      <div className="layout">
        <QdtComponent type="SelectionApi" props={{ clearAll: true }} />
        <section id="qlik-left-nav">
          <div className="container-fluid">
            <div className="row">
              <LeftNav {...props} />
            </div>
            <div className="row border-top-gray pt15">
              <div className="col-md-12 text-right">
                <a href="https://www.qlik.com"><img src="assets/powered-by-Qlik-Horizontal.png" alt="PoweredByQlik" className="logo" /></a>
              </div>
            </div>
          </div>
        </section>
        <section id="qlik-main">
          <div id="data-overview">
            <div className="hero"><div className="title">OPEN INITIATIVE</div></div>
            <div className="container-fluid">
              <div className="row pb0">
                <div className="col-md-12">
                  <h1 className="pb0">OPEN INITIATIVE</h1>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <p className="pr30">In the spirit of being open, we’ve created the space below to share key data points from our organization, ranging from financial support and impact to membership growth and operational metrics. These data points help us make deliberate investments, draft operational planning objectives, and ensure we deliver impact to communities affected by disasters. </p>
                </div>
                <div className="col-md-6">
                  <p>Our hope is this data proves applicable and insightful to our volunteers, donors, fellow non-profit organizations, academics, and anyone else focused on the goal of helping people and communities in need.</p>
                </div>
              </div>

              <div className="row pb5">
                <div className="col-md-12">
                  <p className="pr30">The following metrics comprise lifetime, organizational high-level indicators of investment, outcomes and impact</p>
                </div>
              </div>

              <div className="row kpis">
                <div className="col-md-4">
                  <h3 className="pb25">INVESTMENTS</h3>
                  <h1>
$
                    <QdtComponent type="QdtKpi" props={{ cols: ["=num(Sum({<[Opportunity Close Year]={'Running Total'}>} TOTAL), '##,##0')"], roundNum: true }} />
                  </h1>
                </div>
                <div className="col-md-4">
                  <h3 className="pb25">MEMBERSHIP</h3>
                  <h1><QdtComponent type="QdtKpi" props={{ cols: ["=num(Count(distinct tr_id), '##,##0')"], roundNum: true }} /></h1>
                  <div><Link to="/members" href="/members" className="lui-button">Learn More ></Link></div>
                </div>
                <div className="col-md-4">
                  <h3>
                    TRAININGS
                    <br />
                    COMPLETED
                  </h3>
                  <h1><QdtComponent type="QdtKpi" props={{ cols: ["=Num(Count(transcript_completion_date), '##,##0')"], roundNum: true }} /></h1>
                  <div><Link to="/training" href="/training" className="lui-button">Learn More ></Link></div>
                </div>
              </div>

              <div className="row kpis">
                <div className="col-md-2 bg-red">
                  <h3 className="pb25 white">OPERATIONS</h3>
                  <h1 className="white"><QdtComponent type="QdtKpi" props={{ cols: ["=num(Count(distinct operation_id), '##,##0')"] }} /></h1>
                  <div className="pb10"><Link to="/operations" href="/operations" className="lui-button btn-red">Learn More ></Link></div>
                </div>
                <div className="col-md-2 bg-red">
                  <h3 className="white">
                    VOLUNTEERS
                    <br />
                    DEPLOYED
                  </h3>
                  <h1 className="white"><QdtComponent type="QdtKpi" props={{ cols: ["=Num(Sum([tr_volunteers_onscene]), '###,###')"] }} /></h1>
                  <div><Link to="/deployments" href="/deployments" className="lui-button btn-red">Learn More ></Link></div>
                </div>
                <div className="col-md-2 bg-red">
                  <h3 className="white">
                    WORK
                    <br />
                    ORDERS
                  </h3>
                  <h1 className="white"><QdtComponent type="QdtKpi" props={{ cols: ["=num(Sum(work_orders_generated), '##,##0')"] }} /></h1>
                  <div><Link to="/work-orders" href="/work-orders" className="lui-button btn-red">Learn More ></Link></div>
                </div>
                <div className="col-md-2 bg-red">
                  <h3 className="white">
NET PROMOTER
                    <br />
SCORE
                  </h3>
                  <h1 className="white"><QdtComponent type="QdtKpi" props={{ cols: ["=Num(((Count({<NPS_Category={'PROMOTER'}>} client_NPS)/Count(client_NPS))-(Count({<NPS_Category={'DETRACTOR'}>} client_NPS)/Count(client_NPS)))*100, '##.##')"] }} /></h1>
                  <div><Link to="/net-promoter-score" href="/net-promoter-score" className="lui-button btn-red">Learn More ></Link></div>
                </div>
                <div className="col-md-4 bg-red">
                  <h3 className="white">
LABOR
                    <br />
VALUE
                  </h3>
                  <h1 className="white">
$
                    <QdtComponent type="QdtKpi" props={{ cols: ["=num(Sum(volunteer_labor_value)/1000000, '###.##')"] }} />
M
                  </h1>
                  <div><Link to="/labor-value" href="/labor-value" className="lui-button btn-red">Learn More</Link></div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="hero in-the-spotlight">
                    <div className="title">
                      <p className="pb15">OPERATIONAL FOCUS</p>
                      <div><Link to="/operational-focus" href="/operational-focus" className="lui-button">Learn More</Link></div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row border-bottom-gray">
                <div className="col-md-8 pr30">
                  <h1 className="pb15">
IN THE SPOTLIGHT:
                    {' '}
                    <span className="red">HURRICANE FLORENCE</span>
                  </h1>
                  <p className="pb15 pr30">Hurricane Florence floods caused significant and extensive damage throughout the Carolinas. While Florence made landfall over North Carolina as a Category 1 hurricane, its slow speed and heavy rainfall led to record rainfall and flooding throughout the affected areas. Team Rubicon launched Operation Silver Sun in response to Florence, focusing initially on damage assessments and later debris removal and muckouts.</p>
                  <p className="pb15 pr30">
As Team Rubicon’s response to Florence continues, continue to check our Open Initiative for key data points and the
                    {' '}
                    <a href="https://teamrubiconusa.org/operations/operation-silver-sun/">Operation Silver Sun</a>
                    {' '}
page for more information.
                  </p>
                </div>
                <div className="col-md-4 thumb">
                  <Link to="/operational-focus#florence" href="/operational-focus#florence"><img src="assets/DataOverview-IntheSpotlight-Florence.jpg" alt="IntheSpotlight" /></Link>
                </div>
              </div>

              <div className="row border-bottom-gray">
                <div className="col-md-8 pr30">
                  <h1>MEMBERS</h1>
                  <h5 className="pb15 red"><QdtComponent type="QdtKpi" props={{ cols: ["=Num(Count(distinct tr_id), '###,###')&' MEMBERS'"] }} /></h5>
                  <p className="pb25">Volunteers (referred to as Team Rubicon Members or Greyshirts) are the lifeblood of the organization. The unique pairing of the skills and experiences of military veterans with first responders and other specialists allows Team Rubicon to respond quickly and efficiently.</p>
                  <div>
                    <Link to="/members" href="/members" className="lui-button">
Learn More
                      {' '}
                      <i className="fa fa-chevron-right" aria-hidden="true" />
                    </Link>

                  </div>
                </div>
                <div className="col-md-4 thumb">
                  <Link to="/members" href="/members"><img src="assets/DataOverview-Members.jpg" alt="Members" /></Link>
                </div>
              </div>

              <div className="row border-bottom-gray">
                <div className="col-md-8 pr30">
                  <h1>TRAINING</h1>
                  <h5 className="pb15">
                    <span className="red">
                      <QdtComponent type="QdtKpi" props={{ cols: ["=Num(Count(transcript_completion_date), '###,###')"] }} />
                      {' '}
TRAININGS
                    </span>
                    {' '}
AND
                    {' '}
                    <span className="red">
                      <QdtComponent type="QdtKpi" props={{ cols: ["=Num(Sum(updated_training_hours), '###,###')"] }} />
                      {' '}
TRAINING HOURS
                    </span>
                    {' '}
COMPLETED
                  </h5>
                  <p className="pb25">Tactics and skills training for Team Rubicon members provides a knowledge baseline that makes it easier to quickly and efficiently work and respond in disaster zones. </p>
                  <div>
                    <Link to="/training" href="/training" className="lui-button">
Learn More
                      {' '}
                      <i className="fa fa-chevron-right" aria-hidden="true" />
                    </Link>

                  </div>
                </div>
                <div className="col-md-4 thumb">
                  <Link to="/training" href="/training"><img src="assets/DataOverview-Training.jpg" alt="Training" /></Link>
                </div>
              </div>

              <div className="row border-bottom-gray">
                <div className="col-md-8 pr30">
                  <h1>OPERATIONS</h1>
                  <h5 className="pb15">
                    <span className="red">
                      <QdtComponent type="QdtKpi" props={{ cols: ['=Count(distinct operation_id)'] }} />
                      {' '}
OPERATIONS
                    </span>
                    {' '}
IN
                    {' '}
                    <span className="red">
                      <QdtComponent type="QdtKpi" props={{ cols: ['=Count(distinct country)'] }} />
                      {' '}
COUNTRIES
                    </span>
                  </h5>
                  <p className="pb25">Disaster response, mitigation, or recovery operations are constantly being executed and planned across the United States and globe.</p>
                  <div>
                    <Link to="/operations" href="/operations" className="lui-button">
Learn More
                      {' '}
                      <i className="fa fa-chevron-right" aria-hidden="true" />
                    </Link>

                  </div>
                </div>
                <div className="col-md-4 thumb">
                  <Link to="/operations" href="/operations"><img src="assets/DataOverview-Operations.jpg" alt="Operations" /></Link>
                </div>
              </div>

              <div className="row border-bottom-gray">
                <div className="col-md-8 pr30">
                  <h1>WORK ORDERS</h1>
                  <h5 className="pb15 red"><QdtComponent type="QdtKpi" props={{ cols: ["=Num(Sum(work_orders_completed), '###,###')&' COMPLETED WORK ORDERS'"] }} /></h5>
                  <p className="pb25">Work orders - the catch-all term for services provided to a family or individual in need - provide an insight into Team Rubicon's impact after a disaster.</p>
                  <div>
                    <Link to="/work-orders" href="/work-orders" className="lui-button">
Learn More
                      {' '}
                      <i className="fa fa-chevron-right" aria-hidden="true" />
                    </Link>

                  </div>
                </div>
                <div className="col-md-4 thumb">
                  <Link to="/work-orders" href="/work-orders"><img src="assets/DataOverview-WorkOrders.jpg" alt="WorkOrders" /></Link>
                </div>
              </div>

              <div className="row border-bottom-gray">
                <div className="col-md-8 pr30">
                  <h1>NET PROMOTER SCORE</h1>
                  <h5 className="pb15">
ON A SCALE OF 0-10 WE HAVE A
                    {' '}
                    <span className="red">
NET PROMOTER SCORE OF
                      {' '}
                      <QdtComponent type="QdtKpi" props={{ cols: ["=Num(((Count({<NPS_Category={'PROMOTER'}>} client_NPS)/Count(client_NPS))-(Count({<NPS_Category={'DETRACTOR'}>} client_NPS)/Count(client_NPS)))*100, '##.##')"] }} />
                    </span>
                  </h5>
                  <p className="pb25">The Net Promoter Score (NPS) is an industry-standard metric to measure the level of satisfaction Team Rubicon's clients and survivors experience.</p>
                  <div>
                    <Link to="/net-promoter-score" href="/net-promoter-score" className="lui-button">
Learn More
                      {' '}
                      <i className="fa fa-chevron-right" aria-hidden="true" />
                    </Link>

                  </div>
                </div>
                <div className="col-md-4 thumb">
                  <Link to="/net-promoter-score" href="/net-promoter-score"><img src="assets/DataOverview-NPS.jpg" alt="NPS" /></Link>
                </div>
              </div>

              <div className="row border-bottom-gray">
                <div className="col-md-8 pr30">
                  <h1>LABOR VALUE</h1>
                  <h5 className="pb15">
WE HAVE GENERATED THE EQUIVALENT OF
                    {' '}
                    <span className="red">
                      <QdtComponent type="QdtKpi" props={{ cols: ["=Num(Sum(volunteer_labor_value)/1000000, '$##.##')"] }} />
                      {' '}
MILLION IN FREE LABOR
                    </span>
                  </h5>
                  <p className="pb25">While all of Team Rubicon's services are provided free of charge, the financial impact of those services provide a tangible different for families and communities recovering from disaster.</p>
                  <div>
                    <Link to="/value" href="/value" className="lui-button">
Learn More
                      {' '}
                      <i className="fa fa-chevron-right" aria-hidden="true" />
                    </Link>

                  </div>
                </div>
                <div className="col-md-4 thumb">
                  <Link to="/value" href="/value"><img src="assets/DataOverview-LaborValue.jpg" alt="LaborValue" /></Link>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 text-right">
                  <img src="assets/powered-by-Qlik-Horizontal.png" alt="PoweredByQlik" className="logo" />
                </div>
              </div>

            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Page;
